import { useCallback } from 'react';
import { CitationModalContent } from '../CitationModalContent';
const INLINE_CITATION_REGEX = /[?&]hs-inline-citation=([a-f\d-]{36})/;
export function transformInlineCitations(contentText, sources) {
  return contentText.replace(
  // regexr.com/8gell
  /<!-- <cite>(([a-f\d-]{36},?)+)<\/cite> -->/g, (match, citationIds) => {
    const citationsLinks = citationIds.split(',').map(id => {
      const sourceIndex = sources.findIndex(source => source.citationId === id);
      const citedSource = sources[sourceIndex];
      if (citedSource) {
        const deepLink = new URL(citedSource.deepLink);
        deepLink.searchParams.set('hs-inline-citation', citedSource.citationId);
        const href = deepLink.toString();
        return `<a title="${sources[sourceIndex].title}" href="${href}">${sourceIndex + 1}</a>`;
      }
      return id;
    }).join('');
    return `<cite>${citationsLinks}</cite>`;
  });
}
const inlineCitationLinkClickHandler = ({
  e,
  accentColor,
  browserWindowHeight,
  navigateToKnowledgeBaseArticle,
  openModal,
  sources
}) => {
  e.preventDefault();
  const href = e.target.href;
  const match = href.match(INLINE_CITATION_REGEX);
  const citationId = match === null || match === void 0 ? void 0 : match[1];
  const source = sources.find(sourceItem => sourceItem.citationId === citationId);
  if (!source) {
    return;
  }
  openModal(CitationModalContent({
    accentColor,
    browserWindowHeight,
    navigateToKnowledgeBaseArticle,
    source
  }));
};
export function useInlineCitations({
  accentColor,
  browserWindowHeight,
  navigateToKnowledgeBaseArticle,
  openModal,
  sources
}) {
  return useCallback(() => {
    const handleInlineCitationLinkClick = e => {
      inlineCitationLinkClickHandler({
        e,
        accentColor,
        sources: sources || [],
        navigateToKnowledgeBaseArticle,
        browserWindowHeight,
        openModal
      });
    };
    const inlineCitationLinks = document.querySelectorAll('[data-test-use="agent"] a[href*="&hs-inline-citation="], [data-test-use="agent"] a[href*="?hs-inline-citation="]');
    Array.from(inlineCitationLinks).filter(link => INLINE_CITATION_REGEX.test(link.href)).forEach(link => {
      link.removeEventListener('click', handleInlineCitationLinkClick);
      link.addEventListener('click', handleInlineCitationLinkClick);
    });
  }, [accentColor, browserWindowHeight, navigateToKnowledgeBaseArticle, openModal, sources]);
}